var _defs, _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.949,
    height: 56.09,
    viewBox: "0 0 97.949 56.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bbe5f8;}.b{fill:#0b4b7f;}.c{fill:#fff;}.d{fill:#2386c2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.249,0,39.834,17.581H104.3Z",
    transform: "translate(-6.486)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.288,21,0,59.51H97.949V21Z",
    transform: "translate(0 -3.419)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.184 36.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.205,51.36h1.674v1.674H52.205ZM48,51.36h1.674v1.674H48Zm8.411,0h1.674v1.674H56.411ZM48,47.855h1.674V49.53H48Zm4.205,0h1.674V49.53H52.205Zm4.206,0h1.674V49.53H56.411Zm4.205,0H62.29V49.53H60.616ZM48,44h1.674v1.674H48Zm4.205,0h1.674v1.674H52.205Zm4.206,0h1.674v1.674H56.411Zm4.205,0H62.29v1.674H60.616ZM52.205,54.864h1.674v1.674H52.205Zm-4.205,0h1.674v1.674H48Zm8.411,0h1.674v1.674H56.411Zm4.205,0H62.29v1.674H60.616Zm0-3.5H62.29v1.674H60.616Zm12.616,1.752h1.674v1.674H73.232Zm-4.206,0H70.7v1.674H69.026Zm8.411,0h1.674v1.674H77.437Zm4.205,0h1.674v1.674H81.643Zm4.205,0h1.674v1.674H85.848Z",
    transform: "translate(-48 -44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88.186,54.884H89.86v1.674H88.186Zm8.411,0h1.674v1.674H96.6Zm5.607,0h1.674v1.674H102.2Z",
    transform: "translate(-54.543 -45.772)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,56.09l33.155-38.3L48.765,0,0,17.795Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95ff2522aec3263a43d56cd2fcfeb4de.svg";
export { ForwardRef as ReactComponent };